import React from 'react';
import { Pencil } from 'lucide-react';
import styles from './SendMessageStep.module.css';

interface EmailPreviewProps {
  html: string;
  onEdit: () => void;
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({ html, onEdit }) => (
  <figure className={styles.emailPreview}>
    <div className={styles.scrollArea}>
      <iframe srcDoc={html} title="Email Preview" sandbox="allow-same-origin" />
    </div>
    <button type="button" onClick={onEdit}>
      <Pencil />
      <span>Edit</span>
    </button>
  </figure>
);
